import { __extends } from "tslib";
import { clamp } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
import { RANGE_VALUE, PERCENT } from './constant';
// 注册 shape
import './shapes/gauge';
/**
 * 仪表盘盘
 */
var Gauge = /** @class */ (function (_super) {
    __extends(Gauge, _super);
    function Gauge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 图表类型 */
        _this.type = 'gauge';
        return _this;
    }
    Gauge.prototype.getDefaultOptions = function (options) {
        var _a;
        var percent = options.percent;
        return {
            percent: 0,
            range: {
                ticks: [0, clamp(percent, 0, 1), 1],
            },
            innerRadius: 0.9,
            radius: 0.95,
            startAngle: (-7 / 6) * Math.PI,
            endAngle: (1 / 6) * Math.PI,
            syncViewPadding: true,
            axis: {
                line: null,
                label: {
                    offset: -24,
                    style: {
                        textAlign: 'center',
                        textBaseline: 'middle',
                    },
                },
                subTickLine: {
                    length: -8,
                },
                tickLine: {
                    length: -12,
                },
                grid: null,
            },
            indicator: {
                pointer: {
                    style: {
                        stroke: '#1890FF',
                        lineWidth: 5,
                        lineCap: 'round',
                    },
                },
                pin: {
                    style: {
                        stroke: '#1890FF',
                        r: 9.75,
                        lineWidth: 4.5,
                        fill: '#fff',
                    },
                },
            },
            statistic: {
                title: false,
                content: {
                    formatter: function (_a) {
                        var percent = _a.percent;
                        return (percent * 100).toFixed(2) + "%";
                    },
                    style: {
                        opacity: 0.75,
                        fontSize: 30,
                        textAlign: 'center',
                        textBaseline: 'bottom',
                    },
                    offsetY: -16,
                },
            },
            meta: (_a = {},
                // 两个 view 的 scale 同步到 v 上
                _a[RANGE_VALUE] = {
                    sync: 'v',
                },
                _a[PERCENT] = {
                    sync: 'v',
                },
                _a),
        };
    };
    /**
     * 获取适配器
     */
    Gauge.prototype.getSchemaAdaptor = function () {
        return adaptor;
    };
    return Gauge;
}(Plot));
export { Gauge };
//# sourceMappingURL=index.js.map